import { BrandKitField } from "@arrowsup/platform-dtos";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { BrandKitFieldValue, describeFieldType } from "./brand-kit-field-value";

/** Read-only list of a version's fields. */
export const BrandKitFieldsView: React.FC<{ fields: BrandKitField[] }> = ({
  fields,
}) => {
  if (fields.length === 0) {
    return <Typography color="text.secondary">No fields.</Typography>;
  }

  return (
    <Stack divider={<Divider flexItem />} spacing={2}>
      {fields.map((field) => (
        <Box key={field.key} display="flex" gap={3} flexWrap="wrap">
          <Box sx={{ width: 240, flexShrink: 0 }}>
            <Typography variant="subtitle1">{field.label}</Typography>
            <Typography variant="caption" color="text.secondary">
              {describeFieldType(field)}
            </Typography>
            {field.description && (
              <Typography variant="body2" color="text.secondary" mt={0.5}>
                {field.description}
              </Typography>
            )}
          </Box>
          <Box flex={1} minWidth={200}>
            <BrandKitFieldValue field={field} />
          </Box>
        </Box>
      ))}
    </Stack>
  );
};
